import axios from 'axios'

/**
 * Retorna o país do visitante pelo IP (backend usa ip-api.com).
 * @returns {Promise<{ country: string }>} ex: { country: 'BR' } ou { country: 'US' }
 */
export const getGeo = async () => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/geo`)
  return data
}
